import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { SharedModule } from '../../shared.module';
import { ImageBoxLinkComponent } from '../image-box-link/image-box-link.component';
import { AppMaterialModule } from '../../material.module';

@Component({
    selector: 'app-logo-header',
    templateUrl: './logo-header.component.html',
    standalone: true,
    imports: [
        AppMaterialModule,
        ImageBoxLinkComponent,
    ],
    styleUrls: ['./logo-header.component.scss']
})
export class LogoHeaderComponent implements OnDestroy {

    @Input() noClick: boolean = false;
    @Input() url: string | null = '';
    @Input() border: boolean = false;
    @Input() size: string = '';
    @Input() hideOnLoading = false;
    @Input() tooltip: string = '';
    @Input() tooltipPosition: TooltipPosition = 'above';
    
    @Output() onClickEmit = new EventEmitter();
    @Output() loaded = new EventEmitter<void>();

    emit_onClick() {
        this.onClickEmit.emit();
    }

    emit_onLoaded() {
        this.loaded.emit();
    }

    ngOnDestroy(): void {
        this.onClickEmit?.unsubscribe();
        this.loaded?.unsubscribe();
    }
}
